import axios from 'axios';
import useAuthStore from '../stores/authStore';

const API_BASE_URL = 'https://n8n.wajok.com/webhook/api';

const authService = {
    login: async (email, password) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/login`, {
                email,
                password,
            }, {
                withCredentials: true // 쿠키 설정을 위해 중요
            });

            if (response.data.status === '0000') {
                // 스토어에 액세스 토큰 업데이트
                const user = response.data.user;
                useAuthStore.getState().login(response.data.access_token, user);
                localStorage.setItem('wablog_auth_event', `login_${Date.now()}`); // 멀티 탭 동기화용
                return { success: true, data: response.data };
            } else {
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            if (error.response && error.response.data) {
                return { success: false, message: error.response.data.message };
            }
            return { success: false, message: '로그인에 실패했습니다. 다시 시도해주세요.' };
        }
    },

    signup: async (email, password, nickname) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/signup`, {
                email,
                password,
                nickname,
            });
            if (response.data.status === '0000') {
                return { success: true, message: response.data.message };
            } else {
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            if (error.response && error.response.data) {
                return { success: false, message: error.response.data.message };
            }
            return { success: false, message: '회원가입에 실패했습니다. 다시 시도해주세요.' };
        }
    },

    // 의도에 맞게 refreshToken에서 silentRefresh로 이름 변경
    silentRefresh: async () => {
        try {
            const response = await axios.post(`${API_BASE_URL}/login/refresh`, {}, {
                withCredentials: true // 리프레시 토큰 쿠키 전송
            });

            if (response.data.status === '0000') {
                const accessToken = response.data.access_token;
                const user = response.data.user;

                useAuthStore.getState().login(accessToken, user);
                return { success: true, access_token: accessToken, user };
            } else {
                return { success: false };
            }
        } catch (error) {
            return { success: false };
        }
    },

    logout: async () => {
        try {
            // 선택사항: 백엔드 호출하여 쿠키 삭제
            await axios.post(`${API_BASE_URL}/logout`, {}, { withCredentials: true });
        } catch (error) {
            // 로그아웃 시 에러 무시            
        } finally {
            useAuthStore.getState().logout();
            localStorage.setItem('wablog_auth_event', `logout_${Date.now()}`); // 멀티 탭 동기화용
        }
    }
};

export default authService;
